import React from "react";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import sidbarActiveBg from "../../assets/img/sidebarActiveBg.jpg";
import sidebarActiveMinBg from "../../assets/img/sidebarActiveMinBg.jpg";

const CustomizedListItem = withStyles({
  root: {
    borderRadius: 12,
    height: 40,
    margin: "5px 0",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#FCFF00",
      color: "#fff",
    },
  },
  button: {
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "&$selected": {
      color: "#000",
    },
  },
  selected: ({ isHide }) => ({
    background: `url(${
      isHide ? sidebarActiveMinBg : sidbarActiveBg
    }) lightgray 50% / cover no-repeat`,
    color: "#fff",
    opacity: "1",
  }),
})(ListItem);

const CustomListItem = (props) => {
  return <CustomizedListItem {...props} />;
};

export default CustomListItem;
